// extracted by mini-css-extract-plugin
module.exports = {"tripleContent":"tripleContent_tripleContent__ItkNi","tripleContentItem":"tripleContent_tripleContentItem__TRnaT"};